#import "../fragments/scheduler-page-config-fragment.graphql"

query GetSchedulerPageConfig($userId: ID) {
    schedulerPageConfig(userId: $userId) {
        ...SchedulerPageConfigFragment
    }
}
